
import moment from 'moment'
import { mapGetters } from 'vuex'
import Loggable from './Loggable'
import Userable from './Userable'
import FranceLog from '@/Models/Static/FiscalCountry/FranceLog'

export default {
  mixins: [
    Loggable,
    Userable,
  ],

  data: () => ({
    FranceLog,
  }),

  computed: {
    turn: {
      get () {
        return this.$store.state.cashControl.turn
      },
      set (v) {
        this.$store.commit('cashControl/turn', v)
      },
    },
    openingTurn () {
      return ! this.turn
    },
    needManualTurn () {
      return this.openingTurn
        ? (!! this.cashPayment?.requiresEndTill)
        : this.endTillPaymentMethods.length > 0
    },
    ...mapGetters('rummage', [
      'cashier',
      'cashPayment',
      'endTillPaymentMethods',
    ]),
  },

  methods: {
    manageTurn (e) {
      if (e != 'mustOpenTurn' && e != 'mustCloseTurn') {
        this.$store.dispatch('xError', e)
        return
      }
      this.can('turns')
        ? this.$store.commit('cashControl/confirm', e)
        : this.$store.dispatch('alert/showWarning', this.__(e))
    },
    setTurn () {
      return this.needManualTurn ? this.manualTurn() : this.autoTurn()
    },
    manualTurn () {
      this.logTurn('Manual turn')
      return this.$store.dispatch('cashControl/form/open')
    },
    autoTurn () {
      return this.openingTurn
        ? this.openAutoTurn()
        : this.closeAutoTurn()
    },
    openTurn (till) {
      this.logTurn('Opening turn...')
      return this.$api(['save', 'Turn'], {
        id: null,
        opened: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        tenantUser_id: this.user.id,
        cashier_id: this.cashier?.id,
        till_start: till,
      })
        .then(r => {
          this.turn = r.data
          this.logTurn('Opened')
        })
        .catch(e => this.$store.dispatch('xError', e))
    },
    openAutoTurn () {
      this.logTurn('Open Auto Turn')
      return this.openTurn({'100': 0,'1': 0})
    },
    async closeTurn (tills) {
      await this.sendLogFromSpa()
      this.logTurn('Closing turn...')
      return this.$api('closeTurn', {
        turnId: this.turn.id,
        till_end: tills.cash,
        till_end_card: tills.card,
        other_till_ends: tills.other,
      })
        .then(r => {
          this.$logFrance(this.FranceLog.PERIOD_CLOSING, `Turn ${this.turn.id} closed`)
          this.logTurn('Closed')
          this.turn = null
        })
        .catch(e => this.$store.dispatch('xError', e))
    },
    closeAutoTurn () {
      this.logTurn('Close Auto Turn')
      return this.closeTurn({
        cash: {'100': 0,'1': 0},
        card: null,
        other: null,
      })
    },
    logTurn (action) {
      this.$log(action, 'Turn', this.turn?.id ?? null)
    },
  },
}
